import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as userActions } from '../../actions/userActions';
import * as types from '../../constants/actionTypes';
import Notification from '../Common/Notification';
import PropTypes from 'prop-types';
import Drawer from '../Common/Drawer/Drawer';
import NotificationSettingsForm from '../NotificationSettings/NotificationSettingsForm';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import './UserNotificationsDrawer.scss';
import MomentTz from 'moment-timezone';

export class UserNotificationsDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        const settings = {
            alertOnNewUserRequest: false,
            alertOnLocationCreated: false,
            alertOnTaskAssigned: false,
            alertForDailyDigest: false,
            alertForWeeklyDigest: false,
            alertOnProjectAssigned: false,
            alertOnCommentTag: false,
            alertOnSystemUpdates: false,
            alertOnSpecificLocations: 0,
            alertOnNeedResources: false,
            locationIds: '',
            alertDayOfWeekId: '',
            alertHourOfDayId: '',
            timezoneOffset: 0,
            timezoneString: "",
            timezone: "",
            isFormValid: true
        };

        this.state = {
            settings,
            isLoading: false
        }
    }

    componentDidMount = () => {
        this.setTimeZone();
    }

    setTimeZone = () => {
        const tz = MomentTz.tz.guess();
        const offsetMinutes = MomentTz.tz(tz)._offset;
        const zone = MomentTz.tz(tz).format("zz");
        this.setState({ timezoneString: `${tz} ${zone}`, timezone: tz, timezoneOffset: offsetMinutes });
    }

    updateSettings = (settings) => {
        this.setState({
            settings: {
                ...this.state.settings,
                ...settings
            }
        });
    }

    isFormValid = () => {
        if (this.state.settings.alertOnSpecificLocations === 1 && (this.state.settings.locationIds.trim().length < 1 || !this.state.settings.locationIds.trim())) {
            return false;
        }

        if (this.state.settings.alertHourOfDayId === '' || this.state.settings.alertDayOfWeekId === '') {
            return false;
        }

        return true;
    }

    onSaveChanges = async () => {
        if (this.isFormValid() === false) {
            this.updateSettings({ isFormValid: false });
            return;
        }

        this.updateSettings({ isFormValid: true });

        let locationIds = [];
        if (this.state.settings.alertOnSpecificLocations === 1) {
            locationIds = this.state.settings.locationIds.split(',');
        }

        const request = {
            ...this.state.settings,
            locationIds: locationIds,
            timeZoneOffset: this.state.timeZoneOffset,
            userId: this.props.userId,
            subscriptionId: this.props.subscriptionId
        };

        try {
            this.setState({ isLoading: true });
            const result = await this.props.userActions.saveNotificationSettings(request);

            if (result.type === types.SAVE_NOTIFICATION_SETTINGS_SUCCESS) {
                Notification("success", "Success", "Notification settings updated successfully");
            } else if (result.type === types.SAVE_NOTIFICATION_SETTINGS_FAILURE) {
                Notification("error", "Error", result.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    onCancel = () => {
        this.props.onCancel();
    }

    render() {
        return (
            <Drawer isWide={true} 
                title="User Notifications"
                onSaveClick={this.onSaveChanges}
                saveText='Save'
                onCancelClick={this.onCancel}
                menuButtons={this.props.menuButtons} >
                <LoadingIndicator isLoading={this.state.isLoading}>
                    <NotificationSettingsForm
                        subscriptionId={this.props.subscriptionId}
                        settings={this.state.settings}
                        updateSettings={this.updateSettings}
                        userId={this.props.userId}
                        userRole={this.props.userRole}
                        userFullName={this.props.userFullName}
                        isUsedInDrawer={true}
                        timezone={this.state.timezone}
                        timezoneString={this.state.timezoneString}
                    />
                </LoadingIndicator>
            </Drawer>
        )
    }
}

UserNotificationsDrawer.propTypes = {
    subscriptionId: PropTypes.string.isRequired,
    userId: PropTypes.number.isRequired,
    userRole: PropTypes.string.isRequired,
    userFullName: PropTypes.string.isRequired,
    userActions: PropTypes.object.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    menuButtons: PropTypes.array.isRequired
};



function mapDispatchToProps(dispatch) {
    return {
        userActions: bindActionCreators(userActions, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(UserNotificationsDrawer);
